import {Flex, Text} from "../../../../components";
import React, {useState} from "react";
import styled from "styled-components";
import moment from '../../../../utils/MomentConst';

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg};
`;

const Container = styled(Flex)`
  width: 100%;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
  background: #161930;
  border-radius: 5px;
  padding: 12px 18px;
  margin-bottom: 12px;
`;

const TruncateText = styled(Text.Body)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StatusText = styled(TruncateText)`
  --red: #FF5071;
  --orange: #FFB25C;
  --green: #60FFB0;
  color: var(--${props => props.color || 'green'});
`;

const Release = ({editRelease, deleteRelease, data}) => {

  return (
    <Container align='center' minw="840px">
      <Flex w="10%">
        <TruncateText>{data.password}</TruncateText>
      </Flex>
      <Flex w="15%">
        <TruncateText>{data.Type.name} | {data.Type.label}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{data.stock_amount}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{data.force_cancel ? "Yes" : "No"}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{data.whitelist ? (data.whitelist.includes(',') ? data.whitelist.split(',').length : '1') : '0'}</TruncateText>
      </Flex>
      <Flex w="10%">
        <TruncateText>{moment(data.createdAt).format('MMMM D, YYYY, HH:MM:SS')}</TruncateText>
      </Flex>
      <Flex fg="1" />
      <Button bg="#0393FF" onClick={() => editRelease(data)}>Edit</Button>
      <Flex w="12px" />
      <Button bg="#FF5071" onClick={() => deleteRelease(data.id)}>Delete</Button>
    </Container>
  )
}

export default Release;
